import type { ClipperRankBadge, ClipperRankFamily } from './types';

export function seasonFamilyRestTierId({
  titleId,
  featuredTierId,
}: {
  titleId?: string | null;
  featuredTierId?: string | null;
}): string | null {
  return titleId || featuredTierId || null;
}

export function seasonFanBadges({
  family,
  displayedSeasonId,
}: {
  family: ClipperRankFamily;
  displayedSeasonId?: string | null;
}): ClipperRankBadge[] {
  if (!displayedSeasonId) return family.badges;
  const head = family.badges.filter(
    (badge) => badge.season_id === displayedSeasonId,
  );
  const tail = family.badges.filter(
    (badge) => badge.season_id !== displayedSeasonId,
  );
  return [...head, ...tail];
}

export function familyExtraBadges({
  family,
  restTierId,
  displayedSeasonId,
}: {
  family: ClipperRankFamily;
  restTierId?: string | null;
  displayedSeasonId?: string | null;
}): ClipperRankBadge[] {
  const ordered = seasonFanBadges({ family, displayedSeasonId });
  if (!restTierId) return ordered;

  const restIndex = ordered.findIndex((badge) => {
    if (badge.tier_id !== restTierId) return false;
    if (family.id === 'season' && displayedSeasonId) {
      return badge.season_id === displayedSeasonId;
    }
    return true;
  });
  if (restIndex < 0) return ordered;
  return ordered.filter((_, index) => index !== restIndex);
}
